export default __webpack_public_path__ + "static/media/css.a6c35056.svg";